
import {
  computed,
  defineComponent, onMounted, onUnmounted, ref,
} from 'vue';
import RefreshPull from 'pull-refresh-vue3';
/* eslint-disable import/no-cycle */
import { useRoute, useRouter } from 'vue-router';
import { useMainStore } from '@/store/mainStore';
import { useSpacesStore } from '../../spaces/store/spacesStore';
// import SpacesMy from '@/modules/spaces/components/SpacesMy.vue';
import { useMessagesStore } from '../store/messagesStore';
import MessagesConversations from '../components/MessagesConversations.vue';
import MessageGroupChatCreate from '../components/MessageGroupChatCreate.vue';
// import MessageGroupsList from '../components/MessageGroupsList.vue';
import MonitoringService from '@/services/MonitoringService';
import UsePullToRefresh from '@/composables/UsePullToRefresh';
import NativeService from '@/services/NativeService';
import AppNoMessage from '@/components/AppNoMessage.vue';

export default defineComponent({
  components: {
    // SpacesMy,
    MessagesConversations,
    MessageGroupChatCreate,
    // MessageGroupsList,
    RefreshPull,
    AppNoMessage,
  },
  setup() {
    const spacesStore = useSpacesStore();
    const messagesStore = useMessagesStore();
    const mainStore = useMainStore();
    const hasData = computed(() => spacesStore.myContacts.length > 0 || messagesStore.conversations.length > 0 || messagesStore.groupsForChat.length > 0);
    const noData = computed(
      () => !spacesStore.filteredMyContacts.length
        && !spacesStore.filteredByNameGroupsByOwnerId.length
        && !messagesStore.filteredConversations.length,
    );

    const createGroup = ref(false);
    const isGroupInfoOpen = ref(false);

    function shareApp(): void {
      if (mainStore.isNative) {
        NativeService.shareApp();
      }
    }

    function refreshMessages() {
      return Promise.all([
        messagesStore.fetchConversations(),
        messagesStore.fetchGroupsForChat(),
      ]);
    }

    const {
      loadingPull, loosingText, successText, pullingText, loadingText, onRefresh,
    } = UsePullToRefresh(refreshMessages);

    const route = useRoute();
    const router = useRouter();

    function checkRouterQuery() {
      if (route.query.createGroup) {
        createGroup.value = true;
        router.replace({});
      }
    }

    onMounted(() => {
      checkRouterQuery();
      MonitoringService.sendPageMountedSpeed();
    });

    onUnmounted(() => {
      spacesStore.search = '';
    });

    return {
      spacesStore,
      mainStore,
      messagesStore,
      createGroup,
      isGroupInfoOpen,
      hasData,
      noData,

      loadingPull,
      loosingText,
      successText,
      pullingText,
      loadingText,
      onRefresh,
      shareApp,
    };
  },
});
